exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media screen {\n  .cs-ProgressBar {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    position: fixed;\n    width: 60%;\n    max-width: 500px;\n    bottom: 0;\n    height: 20px;\n  }\n}\n.cs-ProgressBar__box {\n  width: 100%;\n  height: 100%;\n  border-radius: 25px;\n  background-color: gray;\n  padding: 5px;\n  box-shadow: inset 0 -1px 1px rgba(255, 255, 255, 0.3);\n}\n@media print {\n  .cs-ProgressBar__box {\n    display: none;\n  }\n}\n.cs-ProgressBar__box--bar {\n  display: block;\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-top-left-radius: 20px;\n  border-bottom-left-radius: 20px;\n  position: relative;\n  overflow: hidden;\n  min-width: 1%;\n  height: 100%;\n  background-color: #d21034;\n}\n.cs-ProgressBar--print {\n  position: absolute;\n  top: 65px;\n}\n@media screen {\n  .cs-ProgressBar--print {\n    display: none;\n  }\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/components/ProgressBar/ProgressBar.less
// module id = 914
// module chunks = 0